import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Themes from "./themes";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { CssBaseline, MuiThemeProvider } from "@material-ui/core";
// import { ThemeProvider } from "@material-ui/styles";
import { BrowserRouter, Route } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import ModalProvider from "components/CustomConfirm/ModalProvider";
import { AnalyticsProvider } from "@zennya/web-component-library/src";
import { RecoilRoot } from "recoil";

// if (!new class { x }().hasOwnProperty('x')) throw new Error('Transpiler is not configured correctly');

import moment from 'moment-timezone'

moment.tz.setDefault('Asia/Manila')

if ("virtualKeyboard" in navigator) {
  navigator.virtualKeyboard.overlaysContent = true;
}


ReactDOM.render(
  <RecoilRoot>
  <MuiThemeProvider theme={Themes.default}>
    <CssBaseline>
      <ModalProvider>
        <DndProvider backend={HTML5Backend}>
          <BrowserRouter >
            <QueryParamProvider ReactRouterRoute={Route}>
              <App />
            </QueryParamProvider>
          </BrowserRouter>
        </DndProvider>
      </ModalProvider>
    </CssBaseline>
  </MuiThemeProvider>
  </RecoilRoot>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
